export default __webpack_public_path__ + "static/media/Thumb_Bottom_03.a847265a.png";